import React from "react";
import { Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";
import { StickyWhatsApp, MobileBottomBar } from "./StickyCTAs";
import VisitorTracker from "./VisitorTracker";
import SubscriptionBar from "./SubscriptionBar";

export default function Layout() {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-white text-slate-900 has-bottom-bar">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <SubscriptionBar />
        <Footer />
        <StickyWhatsApp />
        <MobileBottomBar />
        <Toaster richColors position="top-center" />
        <VisitorTracker />
      </div>
    </HelmetProvider>
  );
}
